import React from 'react';
import { Animated } from './styled';

const AnimatedDots = () => {
  return (
      <span>
        <Animated>
          <Animated.Dot className={'first'}>.</Animated.Dot>
          <Animated.Dot className={'second'}>.</Animated.Dot>
          <Animated.Dot className={'third'}>.</Animated.Dot>
        </Animated>
      </span>
    )
};

export default AnimatedDots;